import React from 'react';
import classNames from 'classnames';

import { Button, Typography, Box, Tooltip } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import SaveIcon from '@mui/icons-material/Save';
import StripePattern from './StripePattern';
import { TFunction } from 'i18next';

interface Props {
	disabled: boolean;
	loading: boolean;
	onClick: () => void;
	t: TFunction;
}

const SaveButton = ({ disabled, loading, onClick, t }: Props) => {
	const classes = useStyles();

	const getButtonText = () => {
		switch (true) {
			case loading:
				return t('common:states.saving') + '...';
			case disabled:
				return t('common:actions.save');
			default:
				return t('common:actions.save');
		}
	};

	return (
		<Box display="flex" flexDirection="column" justifyContent="center" height="60px">
			<Button
				disabled={disabled || loading}
				color="primary"
				variant="contained"
				onClick={onClick}
				data-qa="saveButton"
				classes={{ root: classes.button }}
			>
				<Typography className={classes.buttonText} variant="button">
					{getButtonText()}
				</Typography>
				<StripePattern animationSpeed="fast" color="light" tint="primary" hidden={!loading} />
			</Button>
		</Box>
	);
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		button: {
			minWidth: '150px',
			position: 'relative',
			overflow: 'hidden',
			marginTop: theme.spacing(1.5),
			marginBottom: theme.spacing(1.5),
			zIndex: 1,
		},
		buttonText: {
			position: 'relative',
			zIndex: 10,
		},
	}),
);

export default SaveButton;
